export const SEARCH_CATEGORY = 'Search';
const TYPEAHEAD_SHOWN = 'typeahead-shown';
const TYPEAHEAD_SELECTED = 'typeahead-selected';

const TYPEAHEAD_EXPERIENCE_VIEWED = 'typeahead-experience-viewed';
const TYPEAHEAD_EXPERIENCE_OPENED = 'typeahead-experience-opened';
const TYPEAHEAD_EXPERIENCE_CLOSED = 'typeahead-experience-closed';
const TYPEAHEAD_EXPERIENCE_RETURNED = 'typeahead-experience-returned';
const TYPEAHEAD_EXPERIENCE_ITEM_CLICKED = 'typeahead-experience-item-clicked';

const makeLabel = ({
  screen,
  keywords,
  itemIaCode,
  itemType,
  itemPosition,
  inputValue,
  productContextIaCode,
}: any) => {
  const clicked = [
    keywords,
    itemIaCode,
    itemType,
    `${itemPosition || ''}`,
  ].map((e?: any) => e || '').join(':');

  const context = [
    productContextIaCode,
    inputValue,
  ].map((e?: any) => e || '').join(':');

  return [
    screen,
    clicked,
    context,
  ].map((e?: any) => e || '').join('|');
};

// eslint-disable-next-line import/prefer-default-export
export const analyticsPayload = {
  typeaheadShown: () => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_SHOWN,
  }),
  typeaheadSelected: (selected?: any, textInBox?: any) => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_SELECTED,
    label: `${selected}:${textInBox}`,
  }),
  typeaheadExperienceOpened: (opts?: any) => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_EXPERIENCE_OPENED,
    label: makeLabel(opts),
    transport: 'beacon',
  }),
  typeaheadExperienceClosed: (opts?: any) => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_EXPERIENCE_CLOSED,
    label: makeLabel(opts),
    transport: 'beacon',
  }),
  typeaheadExperienceItemClicked: (opts?: any) => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_EXPERIENCE_ITEM_CLICKED,
    label: makeLabel(opts),
    transport: 'beacon',
  }),
  typeaheadExperienceReturned: (opts?: any) => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_EXPERIENCE_RETURNED,
    label: makeLabel(opts),
    transport: 'beacon',
  }),
  typeaheadExperienceViewed: (opts?: any) => ({
    category: SEARCH_CATEGORY,
    action: TYPEAHEAD_EXPERIENCE_VIEWED,
    label: makeLabel(opts),
    transport: 'beacon',
  }),
};
